module.exports = "<div class=\"content-snack-bar\">\n    {{mensaje}} <span class=\"text-close\" (click)=\"cerrar();\"> Cerrar!  </span>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared/mensaje-snack-bar/mensaje-snack-bar.component.html
// module id = ./src/app/components/shared/mensaje-snack-bar/mensaje-snack-bar.component.html
// module chunks = main